(function () {
  // Données données par la section du modèle
  var NOM_GAMME = (typeof window.GAMME_NOM === 'string') ? window.GAMME_NOM : '';
  var PAGE_HANDLE = (typeof window.GAMME_PAGE_HANDLE === 'string') ? window.GAMME_PAGE_HANDLE : '';
  var ATTENDU = parseInt(window.GAMME_TOTAL, 10) || 0;   // nombre de produits de la collection
  var TEXTE_LIEN_DEBUT = 'Voir toutes les ';

  // La grille est construite dès que Globo a affiché tous ses produits ; au bout de ce délai (ms), on la construit quoi qu'il arrive
  var DELAI_MAX_GRILLE = 1500;

  var RATIO_PHOTO = 100;      // hauteur du cadre photo produit en % de sa largeur (100 = carré)
  var FOND_CARTE = '#f5f4f2'; // fond des cartes produit
  var NOM_COULEUR = '#000000';  // couleur du nom du produit
  var NOM_POIDS = '500';        // graisse du nom (400 = normal, 500 = medium, 600 = semi gras)
  var PRIX_COULEUR = '#6b6b6b'; // couleur du prix
  var PRIX_POIDS = '400';       // graisse du prix
  var LIEN_COULEUR = '#1a1a1a'; // couleur du lien vers la collection de la taille
  var TAILLE_TEXTE = '14px';    // taille du nom et du prix
  var MARGE_TEXTE = '20px';     // marge à gauche et à droite du nom et du prix, dans la carte

  // Cadrage de la photo de bannière sur ordinateur (50% = centre, plus bas = vers le haut de la photo).
  // POSITION_IMAGE_PC est le cadrage par défaut. POSITION_PAR_GAMME peut donner un cadrage propre à une gamme,
  // la clé est l'adresse de la collection de la gamme, par exemple { 'dourbie': 'center 30%' }. Vide = tout au centre.
  var POSITION_IMAGE_PC = 'center center';
  var POSITION_PAR_GAMME = {};
  var POSITION_IMAGE_MOBILE = 'center center';

  // Grand titre (la dimension, par exemple 120 cm)
  var TITRE_TAILLE_PC = 'clamp(48px, 5.4vw, 90px)';
  var TITRE_TAILLE_MOBILE = '40px';
  var UNITE_TAILLE = '0.45em';       // taille de "cm" par rapport au chiffre
  var SURTITRE_ESPACE_PC = '1.1rem'; // espace entre la petite ligne et le grand titre
  var OMBRE_TEXTE = '0 1px 14px rgba(0, 0, 0, 0.35)';
  var DEGRADE_BANNIERE = 'linear-gradient(to top, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0) 65%)';

  // Ordinateur : hauteur des bannières, en pourcentage de la hauteur de l'écran (100 = plein écran)
  var HERO_PC_HAUTEUR = 90;
  var HERO_PC_MIN = 540;
  // 'cover' = la photo remplit toute la bannière en étant coupée
  // 'contain' = la photo s'affiche entière, avec une couleur de fond de chaque côté
  var IMAGE_AJUSTEMENT_PC = 'cover';
  var FOND_BANNIERE_PC = '#d9d4cc';  // couleur de fond de la bannière (visible seulement avec 'contain')

  // Mobile : le titre passe sous la photo, en noir sur fond blanc
  var FOND_TEXTE_MOBILE = '#ffffff';
  var IMAGE_MOBILE_RATIO = 100;  // hauteur de la photo sur mobile, en % de sa largeur (100 = carré)
  var IMAGE_MOBILE_MIN = 320;

  var donnees = document.getElementById('tailles-data');
  if (!donnees) return;
  var tailles = JSON.parse(donnees.textContent);   // dans l'ordre : 120, 80, 60, 44 cm
  var tailleDe = {};        // adresse du produit, indice de la taille
  var premierRenduOk = !ATTENDU;   // sans nombre attendu, on construit dès que possible

  // Les listes de produits par taille et la photo de chaque bannière sont fournies par la page
  tailles.forEach(function (t, i) {
    (t.handles || []).forEach(function (h) {
      if (!tailleDe.hasOwnProperty(h)) tailleDe[h] = i;
    });
    if (t.pick && t.pick.m) t.banniere = { s: t.pick.s, m: t.pick.m, l: t.pick.l };
  });

  // Cadrage de cette page : celui de sa gamme si elle en a un, sinon le cadrage par défaut
  var POSITION_PAGE = POSITION_PAR_GAMME.hasOwnProperty(PAGE_HANDLE) ? POSITION_PAR_GAMME[PAGE_HANDLE] : POSITION_IMAGE_PC;

  var UNITE_VH = (window.CSS && CSS.supports && CSS.supports('height', '1svh')) ? 'svh' : 'vh';

  function log() {
    try { console.log.apply(console, ['[tailles]'].concat(Array.prototype.slice.call(arguments))); } catch (e) {}
  }

  function poser(el, styles) {
    for (var k in styles) {
      if (styles.hasOwnProperty(k)) el.style.setProperty(k, styles[k], 'important');
    }
  }

  function each(selecteur, fn) {
    Array.prototype.forEach.call(document.querySelectorAll(selecteur), fn);
  }

  function revelerListe() {
    document.documentElement.classList.remove('tailles-attente');
  }

  // "Vasques en pierre 120 cm" devient la dimension "120 cm"
  function dimensionDe(titre) {
    var t = (titre || '').replace(/\s+/g, ' ').trim();
    var m = t.match(/^(.*?)\s*(\d.*)$/);
    if (m && m[1]) return m[2];
    return t;
  }

  // "120 cm" devient "120" et "cm"
  function separerUnite(nom) {
    var m = (nom || '').match(/^(\d+(?:[.,]\d+)?)\s*([^\d\s].*)$/);
    if (m) return { valeur: m[1], unite: m[2] };
    return null;
  }

  function minusculeInitiale(t) {
    t = t || '';
    return t.charAt(0).toLowerCase() + t.slice(1);
  }

  // Sur téléphone et petite tablette, la page peut être plus large que l'écran si un élément déborde :
  // on prend alors la plus petite des deux largeurs. Sur ordinateur, on garde la largeur de la fenêtre.
  function largeurEcran() {
    var w = window.innerWidth;
    var s = (window.screen && window.screen.width) ? window.screen.width : w;
    if (s <= 900) return Math.min(w, s);
    return w;
  }

  function pleineLargeur(el) {
    var largeur = Math.min(document.documentElement.clientWidth, largeurEcran());
    poser(el, { 'width': largeur + 'px', 'max-width': 'none', 'margin-left': '0px' });
    var gauche = el.getBoundingClientRect().left;
    poser(el, { 'margin-left': (-gauche) + 'px' });
  }

  function nbCol() {
    return largeurEcran() >= 990 ? 4 : 2;
  }

  function relancerImages() {
    try {
      if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.checkElems();
    } catch (e) {}
    window.dispatchEvent(new Event('scroll'));
  }

  // ---------- Cartes produit ----------

  function styleCarte(colonne) {
    poser(colonne, { 'background-color': FOND_CARTE });

    var carte = colonne.querySelector('.spf-product-card');
    if (!carte) return;

    poser(carte, { 'margin': '0', 'padding': '0', 'background-color': FOND_CARTE });

    var inner = carte.querySelector('.spf-product-card__inner');
    if (inner) poser(inner, { 'margin': '0', 'padding': '0' });

    var cadre = carte.querySelector('.spf-product-card__image-wrapper');
    if (cadre) poser(cadre, { 'padding-top': RATIO_PHOTO + '%' });

    Array.prototype.forEach.call(carte.children, function (bloc, i) {
      if (i === 0) return;
      poser(bloc, {
        'margin': '0',
        'padding': '14px ' + MARGE_TEXTE + ' 22px ' + MARGE_TEXTE,
        'background-color': FOND_CARTE,
        'color': NOM_COULEUR,
        'font-size': TAILLE_TEXTE
      });

      Array.prototype.forEach.call(bloc.querySelectorAll('a, h1, h2, h3, h4, p, span, div'), function (el) {
        poser(el, {
          'color': NOM_COULEUR,
          'font-size': TAILLE_TEXTE,
          'font-weight': NOM_POIDS,
          'line-height': '1.4',
          'letter-spacing': '0.01em'
        });
      });

      Array.prototype.forEach.call(bloc.querySelectorAll('[class*="price"], [class*="price"] *'), function (el) {
        poser(el, { 'color': PRIX_COULEUR, 'font-size': TAILLE_TEXTE, 'font-weight': PRIX_POIDS });
      });
    });
  }

  function styliser() {
    var w = largeurEcran();
    var mobile = w < 750;
    var largeurPage = Math.min(document.documentElement.clientWidth, w);
    var nbColonnes = nbCol();

    each('.gammes', function (el) {
      poser(el, { 'display': 'block', 'width': '100%' });
    });

    each('.gamme', function (el) {
      poser(el, { 'display': 'block', 'margin-bottom': '5rem' });
    });

    each('.gamme_hero', function (el) {
      var hauteur, minH, maxH;
      if (mobile) {
        hauteur = 'auto'; minH = '0'; maxH = 'none';
      } else {
        hauteur = HERO_PC_HAUTEUR + UNITE_VH; minH = HERO_PC_MIN + 'px'; maxH = '1200px';
      }
      poser(el, {
        'position': 'relative',
        'display': 'block',
        'height': hauteur,
        'min-height': minH,
        'max-height': maxH,
        'overflow': mobile ? 'visible' : 'hidden',
        'color': '#ffffff',
        'text-decoration': 'none',
        'background-color': mobile ? FOND_TEXTE_MOBILE : FOND_BANNIERE_PC
      });
      pleineLargeur(el);
    });

    each('.gamme_hero_image', function (el) {
      var st = {
        'width': '100%',
        'max-width': 'none',
        'max-height': 'none',
        'object-fit': mobile ? 'cover' : IMAGE_AJUSTEMENT_PC,
        'object-position': mobile ? POSITION_IMAGE_MOBILE : POSITION_PAGE,
        'opacity': '1',
        'visibility': 'visible',
        'display': 'block',
        'background-color': 'transparent'
      };
      if (mobile) {
        st['position'] = 'relative';
        st['top'] = 'auto';
        st['left'] = 'auto';
        st['height'] = Math.max(IMAGE_MOBILE_MIN, Math.round(largeurPage * IMAGE_MOBILE_RATIO / 100)) + 'px';
      } else {
        st['position'] = 'absolute';
        st['top'] = '0';
        st['left'] = '0';
        st['height'] = '100%';
      }
      poser(el, st);
    });

    each('.gamme_hero_voile', function (el) {
      poser(el, {
        'display': mobile ? 'none' : 'block',
        'position': 'absolute',
        'top': '0',
        'left': '0',
        'right': '0',
        'bottom': '0',
        'z-index': '1',
        'pointer-events': 'none',
        'background': DEGRADE_BANNIERE
      });
    });

    each('.gamme_hero_texte', function (el) {
      if (mobile) {
        poser(el, {
          'position': 'relative',
          'left': 'auto',
          'bottom': 'auto',
          'z-index': '2',
          'box-sizing': 'border-box',
          'width': '100%',
          'max-width': '100%',
          'padding': '22px 20px 30px 20px',
          'background-color': FOND_TEXTE_MOBILE
        });
      } else {
        poser(el, {
          'position': 'absolute',
          'left': '0',
          'bottom': '0',
          'z-index': '2',
          'box-sizing': 'border-box',
          'width': 'auto',
          'max-width': '52ch',
          'padding': '0 0 clamp(2rem, 3.5vw, 4rem) clamp(2.5rem, 4.5vw, 5rem)',
          'background-color': 'transparent'
        });
      }
    });

    each('.gamme_titre', function (el) {
      poser(el, {
        'color': mobile ? NOM_COULEUR : '#ffffff',
        'margin': '0',
        'font-weight': '300'
      });
    });

    each('.gamme_surtitre', function (el) {
      poser(el, {
        'display': 'block',
        'margin-bottom': mobile ? '0.75rem' : SURTITRE_ESPACE_PC,
        'font-size': mobile ? '15px' : 'clamp(14px, 1.15vw, 19px)',
        'font-weight': '400',
        'letter-spacing': '0.2em',
        'text-transform': 'uppercase',
        'color': mobile ? PRIX_COULEUR : 'inherit',
        'opacity': mobile ? '1' : '0.95',
        'text-shadow': mobile ? 'none' : OMBRE_TEXTE
      });
    });

    each('.gamme_nom', function (el) {
      poser(el, {
        'display': 'block',
        'font-size': mobile ? TITRE_TAILLE_MOBILE : TITRE_TAILLE_PC,
        'font-weight': '300',
        'letter-spacing': '0.03em',
        'line-height': '1.05'
      });
    });

    // L'unité (cm) est plus petite que le chiffre, sur la même ligne de base
    each('.gamme_unite', function (el) {
      poser(el, {
        'font-size': UNITE_TAILLE,
        'font-weight': '300',
        'letter-spacing': '0.08em',
        'vertical-align': 'baseline'
      });
    });

    each('.gamme_entete', function (el) {
      poser(el, { 'margin-bottom': '1.5rem' });
    });

    each('.gamme_liste', function (ul) {
      poser(ul, {
        'display': 'grid',
        'grid-template-columns': 'repeat(' + nbColonnes + ', minmax(0, 1fr))',
        'gap': '0',
        'align-items': 'stretch',
        'list-style': 'none',
        'padding': '0',
        'margin-top': '0',
        'margin-right': '0',
        'margin-bottom': '0'
      });
      pleineLargeur(ul);
      Array.prototype.forEach.call(ul.children, function (c) {
        poser(c, {
          'width': 'auto',
          'max-width': 'none',
          'min-width': '0',
          'flex': 'none',
          'float': 'none',
          'padding': '0',
          'margin': '0'
        });
        styleCarte(c);
      });
    });

    each('.gamme_actions', function (el) {
      poser(el, {
        'display': 'flex',
        'flex-direction': 'column',
        'align-items': 'center',
        'justify-content': 'flex-start',
        'gap': '0',
        'padding': '0',
        'margin-top': '0',
        'margin-right': '0',
        'margin-bottom': '0'
      });
      pleineLargeur(el);
    });

    each('.gamme_lien', function (el) {
      poser(el, {
        'display': 'inline-block',
        'width': 'auto',
        'max-width': 'none',
        'min-height': '0',
        'margin': '1.75rem 0 0 0',
        'padding': '0',
        'border': '0',
        'border-radius': '0',
        'background': 'none',
        'background-color': 'transparent',
        'background-image': 'none',
        'color': LIEN_COULEUR,
        '-webkit-text-fill-color': LIEN_COULEUR,
        'font-family': 'inherit',
        'font-size': mobile ? '13px' : '14px',
        'font-weight': '400',
        'letter-spacing': '0.04em',
        'text-transform': 'none',
        'text-decoration': 'underline',
        'text-underline-offset': '5px',
        'text-align': 'center',
        'box-shadow': 'none'
      });
    });
  }

  function handleDe(colonne) {
    var lien = colonne.querySelector('a[href*="/products/"]');
    if (!lien) return null;
    return lien.getAttribute('href').split('/products/')[1].split('?')[0].split('#')[0];
  }

  // Titre en deux lignes : "Vasque Léman" en petit, puis la dimension en grand ("120" et un "cm" plus petit).
  // Le texte lu par les moteurs de recherche est "Vasque Léman 120 cm".
  function creerTitre(nom) {
    var titre = document.createElement('h2');
    titre.className = 'gamme_titre';

    var surEl = document.createElement('span');
    surEl.className = 'gamme_surtitre';
    surEl.textContent = NOM_GAMME + ' ';

    var nomEl = document.createElement('span');
    nomEl.className = 'gamme_nom';
    var u = separerUnite(nom);
    if (u) {
      nomEl.appendChild(document.createTextNode(u.valeur));
      var uniteEl = document.createElement('span');
      uniteEl.className = 'gamme_unite';
      uniteEl.textContent = ' ' + u.unite;
      nomEl.appendChild(uniteEl);
    } else {
      nomEl.textContent = nom;
    }

    titre.appendChild(surEl);
    titre.appendChild(nomEl);
    return titre;
  }

  // Une section de taille : bannière, grille de produits, lien vers la collection de la taille.
  // Sans taille (produits non classés), la section n'a ni bannière ni lien.
  function creerSection(t) {
    var section = document.createElement('section');
    section.className = 'gamme';
    if (t) section.setAttribute('data-slug', t.slug);

    if (t) {
      var nom = dimensionDe(t.title);
      var titre = creerTitre(nom);
      if (t.banniere) {
        var hero = document.createElement('div');
        hero.className = 'gamme_hero';

        var img = document.createElement('img');
        img.className = 'gamme_hero_image';
        img.alt = NOM_GAMME + ' ' + nom;
        img.decoding = 'async';
        img.loading = 'lazy';
        img.srcset = t.banniere.s + ' 900w, ' + t.banniere.m + ' 1400w, ' + t.banniere.l + ' 2000w';
        img.sizes = '100vw';
        img.src = t.banniere.m;

        var voile = document.createElement('span');
        voile.className = 'gamme_hero_voile';

        var bloc = document.createElement('div');
        bloc.className = 'gamme_hero_texte';
        bloc.appendChild(titre);

        hero.appendChild(img);
        hero.appendChild(voile);
        hero.appendChild(bloc);
        section.appendChild(hero);
      } else {
        var entete = document.createElement('header');
        entete.className = 'gamme_entete';
        entete.appendChild(titre);
        section.appendChild(entete);
      }
    }

    var ul = document.createElement('ul');
    ul.className = 'gamme_liste';
    section.appendChild(ul);

    var actions = document.createElement('div');
    actions.className = 'gamme_actions';
    if (t) {
      var lien = document.createElement('a');
      lien.className = 'gamme_lien';
      lien.href = t.url;
      lien.appendChild(document.createTextNode(TEXTE_LIEN_DEBUT + minusculeInitiale(t.title)));
      var fleche = document.createElement('span');
      fleche.setAttribute('aria-hidden', 'true');
      fleche.textContent = ' \u2192';
      lien.appendChild(fleche);
      actions.appendChild(lien);
    }
    section.appendChild(actions);

    return { section: section, ul: ul };
  }

  // Range les cartes que Globo affiche (donc filtrées) dans les sections de taille
  function faire(reel) {
    var conteneur = document.querySelector('.product-grid-container');
    if (!conteneur) return;
    var liste = conteneur.querySelector('ul.product-grid:not(.gamme_liste)');
    if (!liste) return;

    var colonnes = Array.prototype.slice.call(liste.children).filter(function (c) {
      return c.querySelector('.spf-product-card');
    });

    // Premier rendu : on attend que Globo ait affiché tous ses produits (la grille d'origine n'en contient que 16)
    if (!premierRenduOk) {
      if (colonnes.length < ATTENDU) return;
      premierRenduOk = true;
    }

    var ancien = conteneur.querySelector('.gammes');

    if (!colonnes.length) {
      if (reel === true) {
        if (ancien) ancien.parentNode.removeChild(ancien);
        liste.style.removeProperty('display');
      }
      return;
    }

    if (ancien) ancien.parentNode.removeChild(ancien);

    var parTaille = tailles.map(function () { return []; });
    var sansTaille = [];
    colonnes.forEach(function (c) {
      var h = handleDe(c);
      if (h !== null && tailleDe.hasOwnProperty(h)) parTaille[tailleDe[h]].push(c);
      else sansTaille.push(c);
    });

    var wrap = document.createElement('div');
    wrap.className = 'gammes';

    tailles.forEach(function (t, i) {
      if (!parTaille[i].length) return;
      var s = creerSection(t);
      parTaille[i].forEach(function (c) { s.ul.appendChild(c); });
      wrap.appendChild(s.section);
    });

    if (sansTaille.length) {
      var s2 = creerSection(null);
      sansTaille.forEach(function (c) { s2.ul.appendChild(c); });
      wrap.appendChild(s2.section);
    }

    liste.parentNode.insertBefore(wrap, liste);
    liste.style.setProperty('display', 'none', 'important');
    document.documentElement.classList.add('tailles-actives');

    log(wrap.children.length + ' section(s) affichée(s) | ' + colonnes.length + ' produit(s) sur ' + (ATTENDU || '?') + ' attendus | dont ' + sansTaille.length + ' sans taille | cadrage : ' + POSITION_PAGE + ' | largeur écran ' + largeurEcran() + 'px');
    styliser();
    revelerListe();
    relancerImages();
    setTimeout(function () { styliser(); relancerImages(); }, 300);
  }

  function regrouper(reel) {
    try { faire(reel); } catch (e) { console.error('[tailles] erreur', e); }
  }

  window.regrouperTailles = function () { regrouper(true); };

  window.addEventListener('globoFilterRenderCompleted', function () { regrouper(true); });
  window.addEventListener('resize', function () { styliser(); });
  window.addEventListener('orientationchange', function () { setTimeout(styliser, 250); });
  window.addEventListener('load', function () { styliser(); });

  var minuteur = null;
  function planifier() {
    clearTimeout(minuteur);
    minuteur = setTimeout(function () { regrouper(false); }, 120);
  }

  function demarrer() {
    // Sécurité : au bout de ce délai, la grille est construite avec ce que Globo a affiché
    setTimeout(function () {
      premierRenduOk = true;
      regrouper(false);
      revelerListe();
    }, DELAI_MAX_GRILLE);

    regrouper(false);

    var cible = document.querySelector('.product-grid-container') || document.body;
    try {
      new MutationObserver(planifier).observe(cible, { childList: true, subtree: true });
    } catch (e) { log('observateur indisponible', e); }
    var essais = 0;
    var sonde = setInterval(function () {
      regrouper(false);
      essais++;
      if (essais >= 8) clearInterval(sonde);
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();